/**
 * Mobile sticky "Add to cart" bar. Always visible at the bottom of the
 * screen; clicking it triggers the real add-to-cart button.
 */
class StickyAddToCart extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #sourceButton = null;

  connectedCallback() {
    this.#sourceButton = document.querySelector('product-form-component button[name="add"]');
    const actionButton = this.querySelector('[data-sticky-atc-button]');

    actionButton?.addEventListener('click', this.#handleClick);
  }

  #handleClick = () => {
    this.#sourceButton?.click();
  };
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
